import { useRef, type KeyboardEvent } from 'react';
import { useEnvironment } from '../../context/EnvironmentContext';

export function TotpInput({ value, onChange }: { value: string; onChange: (v: string) => void }) {
  const { accentRing, isSandbox } = useEnvironment();
  const refs = useRef<(HTMLInputElement | null)[]>([]);
  const digits = value.padEnd(6, ' ').slice(0, 6).split('');

  const setDigit = (index: number, char: string) => {
    const next = digits.map((d, i) => (i === index ? char : d === ' ' ? '' : d)).join('').replace(/\s/g, '');
    onChange(next.slice(0, 6));
  };

  const onKey = (index: number, e: KeyboardEvent<HTMLInputElement>) => {
    if (e.key === 'Backspace' && !digits[index]?.trim() && index > 0) {
      refs.current[index - 1]?.focus();
    }
  };

  return (
    <div className="flex gap-2 justify-center">
      {Array.from({ length: 6 }).map((_, i) => (
        <input
          key={i}
          ref={(el) => {
            refs.current[i] = el;
          }}
          type="text"
          inputMode="numeric"
          maxLength={1}
          value={digits[i]?.trim() ? digits[i] : ''}
          onChange={(e) => {
            const c = e.target.value.replace(/\D/g, '').slice(-1);
            setDigit(i, c);
            if (c && i < 5) refs.current[i + 1]?.focus();
          }}
          onKeyDown={(e) => onKey(i, e)}
          className={`w-11 h-12 text-center text-lg font-semibold rounded-xl border border-onyx-border bg-onyx-elevated ${accentRing} ${
            isSandbox ? 'focus:border-onyx-purple' : 'focus:border-onyx-gold'
          }`}
        />
      ))}
    </div>
  );
}
